import { bindable, transient, autoinject, useView } from "aurelia-framework";
import { StepModel } from "../../../../../models/basics/basics.models";
import { type SafetyRatingReviewClientModel } from "../../../../../models/vetting/vetting.models";
import { VesselActivities } from "../../../admin/activities/vessel-activity";
import { UserClaimsService } from "../../../../../services/authentication/user-claims.service";
import { Claims } from "../../../../../constants/authentication/claims";
import { VesselLists } from "../../vessels/steps/vessel-lists";

@autoinject
@transient()
@useView('views/pages/modules/safety-score-review/drawer/safety-score-vessel-details-drawer.html')
export class SafetyScoreVesselDetailsDrawer {

    drawerBigger: boolean = true;

    @bindable
    public safetyScoreReview: SafetyRatingReviewClientModel;

    canViewVesselLists: boolean;

    safetyScoreReviewChanged(newSSR: SafetyRatingReviewClientModel) {
        if (newSSR)
            this.vesselActivity.initialize(newSSR);
    }

    constructor(private vesselActivity: VesselActivities, userClaimsService: UserClaimsService, private vesselLists: VesselLists) {
        this.canViewVesselLists = userClaimsService.hasPermission(Claims.CanViewVesselLists);
        this.tabs = [
            {
                title: "Lists",
                show: () => this.canViewVesselLists,
                step: 1,
                vm: this.vesselLists,
                onClick: () => {
                    this.model = { vesselId: this.safetyScoreReview.vesselId };
                }
            },
            {
                title: "Activities",
                step: 2,
                vm: this.vesselActivity,
                show: true,
                onClick: () => {
                    this.vesselActivity.initialize(this.safetyScoreReview);
                }
            }
        ];
    }

    @bindable
    public showVesselMoreDetailsDrawer: boolean;

    toggleVesselMoreDetailsDrawer() {
        this.showVesselMoreDetailsDrawer = !this.showVesselMoreDetailsDrawer;
    }

    toggleDrawerBigger() {
        this.drawerBigger = !this.drawerBigger;
    }

    model: { vesselId: number } = null;
    public tabs: StepModel[];

    currentTab: StepModel;
}